// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue-material/dist/vue-material.min.css
// module id = 277
// module chunks = 0